var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferRequestNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6369 39.3631C8.83924 37.5655 10.0316 33.7913 9.11656 31.5799C8.16804 29.2874 4.6875 27.4424 4.6875 24.9999C4.6875 22.5575 8.16806 20.7125 9.11657 18.4201C10.0316 16.2086 8.83924 12.4345 10.6369 10.6369C12.4345 8.83924 16.2087 10.0316 18.4201 9.11656C20.7126 8.16804 22.5576 4.6875 25.0001 4.6875C27.4425 4.6875 29.2875 8.16806 31.5799 9.11657C33.7914 10.0316 37.5655 8.83924 39.3631 10.6369C41.1608 12.4345 39.9684 16.2087 40.8834 18.4201C41.832 20.7126 45.3125 22.5576 45.3125 25.0001C45.3125 27.4425 41.8319 29.2875 40.8834 31.5799C39.9684 33.7914 41.1608 37.5655 39.3631 39.3631C37.5655 41.1608 33.7913 39.9684 31.5799 40.8834C29.2874 41.832 27.4424 45.3125 24.9999 45.3125C22.5575 45.3125 20.7125 41.8319 18.4201 40.8834C16.2086 39.9684 12.4345 41.1608 10.6369 39.3631Z",
    stroke: "#3A809E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 19.333L19.334 31.333",
    stroke: "#3A809E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 23.3337C22.288 23.3337 23.3327 22.289 23.3327 21.0003C23.3327 19.7117 22.288 18.667 20.9993 18.667C19.7107 18.667 18.666 19.7117 18.666 21.0003C18.666 22.289 19.7107 23.3337 20.9993 23.3337Z",
    stroke: "#3A809E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6673 31.9997C30.956 31.9997 32.0007 30.955 32.0007 29.6663C32.0007 28.3777 30.956 27.333 29.6673 27.333C28.3787 27.333 27.334 28.3777 27.334 29.6663C27.334 30.955 28.3787 31.9997 29.6673 31.9997Z",
    stroke: "#3A809E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferRequestNew);
export default __webpack_public_path__ + "static/media/Offer_Request_New.d062e95cdcfd7439a39ddccbc7941e5d.svg";
export { ForwardRef as ReactComponent };